import React from 'react';
import ScanAuditLog from '~/components/AgentScanners/components/ScanAuditLog';
import NavigationSidebar from '~/components/NavigationSidebar';
import BaseLayout from '~/layouts/BaseLayout';

class ScanAuditLogLayout extends BaseLayout {
  renderSidebar() {
    return <NavigationSidebar />;
  }

  renderMain() {
    const { route } = this.props;

    return <ScanAuditLog route={route} />;
  }
}

export default ScanAuditLogLayout;
